import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { HeaderCell } from 'common/src/designSystem/components/table/headerCell';
import { HeaderRow } from 'common/src/designSystem/components/table/headerRow';
import { Table } from 'common/src/designSystem/components/table/table';
import { IntervalService } from 'common/src/services/intervalService';
import { useService } from 'common/src/util/dependencies/dependencies';
import { fullName } from 'common/src/vo/positionSlot';
import * as React from 'react';
import { Icon } from '../../designSystem/components/icon';
import { useHeavent } from '../../hooks/useHeavent';
import { TeamRightPanelSlot, useTeamRightPanelContext } from './teamRightPanelContext';
import { TeamRightPanelMemberRow } from './teamRightPanelMemberRow';

interface ITeamRightPanelPositionSlotProps {
    slot: TeamRightPanelSlot;
}

export const TeamRightPanelPositionSlot = (props: ITeamRightPanelPositionSlotProps) => {
    const { translate } = useHeavent();
    const { members } = useTeamRightPanelContext();
    const intervalService = useService(IntervalService);
    const slotName = React.useMemo(
        () =>
            fullName(intervalService, props.slot, props.slot.position.name, {
                slot: { includeRange: true }
            }),
        [props.slot]
    );

    return (
        <Flex
            css={{
                background: 'white',
                bd: true,
                overflow: 'hidden'
            }}
            direction="column"
        >
            <Flex css={{ padding: '$3 $4' }} gap="3">
                <Icon color={props.slot.position.color} icon={props.slot.position.icon} />

                <Flex direction="column">
                    <Box font="gray800 textSm semiBold">{props.slot.position.name}</Box>

                    <Box color="gray500">{slotName}</Box>
                </Flex>
            </Flex>

            <Table hideBorder={true}>
                <HeaderRow>
                    <HeaderCell>{translate('full_name')}</HeaderCell>
                    <HeaderCell />
                </HeaderRow>

                {members.map((member) => (
                    <TeamRightPanelMemberRow
                        key={member.userInfo.id}
                        member={member}
                        slot={props.slot}
                    />
                ))}
            </Table>
        </Flex>
    );
};
